import {
    makeStyles,
    createStyles,
} from '@bb-ui/react-library/dist/components/styles';

const styles = () =>
    createStyles({
        authorConsoleContainer: {
            width: '100%',
        },
    });

const options = {
    name: 'QuickSightConsole-',
};

export const useStyles = makeStyles(styles, options);
